import { useSuspenseQuery } from "@tanstack/react-query";

import { apiGetDiagnosesListOptions, type SupportedDiagnosis } from "../api";
import { queryClient } from "../api/query-client";

/**
 * Supported-diagnoses catalog — global reference data, fetched once per session.
 * `useSupportedDiagnoses` for components (suspends until loaded);
 * `fetchSupportedDiagnoses` for MobX models and route loaders.
 */
function supportedDiagnosesQuery() {
  return { ...apiGetDiagnosesListOptions(), staleTime: Infinity };
}

export function useSupportedDiagnoses(): SupportedDiagnosis[] {
  // Suspends the nearest boundary until loaded, so callers always get data.
  return useSuspenseQuery(supportedDiagnosesQuery()).data.diagnoses;
}

export async function fetchSupportedDiagnoses(): Promise<SupportedDiagnosis[]> {
  const { diagnoses } = await queryClient.ensureQueryData(
    supportedDiagnosesQuery(),
  );
  return diagnoses;
}
